export type DividerProps = {
  dense?: boolean;
};

export function Divider({ dense = false }: DividerProps) {
  const cssClass = dense ? 'm-0' : '';
  return <hr className={`w-100 border-dark ${cssClass}`} />;
}
